export class GoogleMapa {
    constructor(idDivGoogleMaps) {
        this._idDivGoogleMaps = document.getElementById(idDivGoogleMaps);
        this._instanciaMapa   = undefined;
    }

    get instanciaMapa () {
        return this._instanciaMapa;
    }

    iniciarMapa() {
        this._instanciaMapa = new google.maps.Map(this._idDivGoogleMaps, {
            zoom  : 4,
            mapId : '1f49d02c2f4e8e0e',
            center: { lat: -24.923466, lng: -60.918697 },
        });
    }

    /**
     * @return {HTMLButtonElement}
     */
    criarBotao() {
        const htmlButtonElement = document.createElement('button');

        htmlButtonElement.style.backgroundColor = '#fff';
        htmlButtonElement.style.boxShadow       = '0 2px 6px rgba(0,0,0,.3)';
        htmlButtonElement.style.color           = 'rgb(25,25,25)';
        htmlButtonElement.style.margin          = '8px 10px 5px 0';
        htmlButtonElement.type                  = 'button';

        return htmlButtonElement;
    }
}
